var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"font-size":"1.2em","font-weight":"bold"}},[_vm._v("\n   Competência - "+_vm._s(_vm.labelCompetencia)+" -\n   "),_c('span',{staticClass:"badge badge-pill",class:{ 'badge-success' : _vm.isOpen , 'badge-dark' : !_vm.isOpen}},[_vm._v("  "+_vm._s(_vm.labelStatus)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4daeb88","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/Competencia/TitleHeader.vue
// module id = 863
// module chunks = 1